import React from "react";
import Star from "./../../home/section4/Star";
import css from "./section.module.css";
import resources from "../../../../resources";
const UserCard = ({ data }) => {
  const { image, name, title, job_title, ratting, job_desc } = data;
  return (
    <div className={css.user_card}>
      <img className={css.bg_dots} src={resources.icons.dots_2} alt="dots" />
      <div className={css.img_div}>
        <img src={image} alt={name} />
        <div className={css.name_div}>
          <h4>{name}</h4>
          <p>{title}</p>
        </div>
      </div>
      <div className={css.desc}>
        <h4>{job_title}</h4>
        <p>{job_desc}</p>
        <Star stars={ratting} />
      </div>
    </div>
  );
};

export default UserCard;
